import { useEffect } from 'react'
import { I18nextProvider } from 'react-i18next'
import { queryClient } from '@shared/api/queryClient'
import i18n from '@shared/i18n/config'
import { LOCALES } from '@shared/lib'
import { createLanguageChangeInvalidator } from './invalidateOnLanguageChange'

// Swap font when language changes: Kazakh uses Nunito, others use Proxima Nova
function applyFontForLanguage(lang: string) {
  if (lang === LOCALES.kz) {
    document.documentElement.style.setProperty('--font-family-sans', "'Nunito', sans-serif")
  } else {
    document.documentElement.style.setProperty('--font-family-sans', "'Proxima Nova', sans-serif")
  }
}

export function I18nProvider({ children }: { children: React.ReactNode }) {
  useEffect(() => {
    applyFontForLanguage(i18n.language)
    i18n.on('languageChanged', applyFontForLanguage)
    const refetchOnLanguageChange = createLanguageChangeInvalidator(queryClient, i18n.language)
    i18n.on('languageChanged', refetchOnLanguageChange)
    return () => {
      i18n.off('languageChanged', applyFontForLanguage)
      i18n.off('languageChanged', refetchOnLanguageChange)
    }
  }, [])

  return <I18nextProvider i18n={i18n}>{children}</I18nextProvider>
}
